<template>
  <div
    :itemscope="useSchema"
    :itemtype="useSchema ? 'http://schema.org/Product' : undefined"
    class="category-list-wrapper"
  >
    <div
      v-if="useSchema"
      itemscope=""
      itemprop="aggregateRating"
      itemtype="http://schema.org/AggregateRating"
    >
      <meta itemprop="ratingValue" :content="ratings.rating_value" />
      <meta itemprop="reviewCount" :content="ratings.review_count" />
      <meta itemprop="bestRating" :content="ratings.best_rating" />
      <meta itemprop="worstRating" :content="ratings.worst_rating" />
    </div>
    <div itemprop="review" itemtype="https://schema.org/Review" itemscope>
      <div itemprop="author" itemtype="https://schema.org/Person" itemscope>
        <meta itemprop="name" content="Рейтинг Price.ru" />
      </div>
    </div>
    <div
      class="header-title-category-wrap header-title-wrap-bc has-breadcrumbs has-buttons"
    >
      <div class="l-container">
        <h1
          :itemprop="useSchema ? 'name' : undefined"
          class="inline desktop-margin heading-l"
        >
          {{ data.h1 }}
        </h1>
        <span v-if="count" class="tablet-count body-l-medium">
          {{ count && tabletCount }}
        </span>
        <meta
          v-if="useSchema"
          itemprop="description"
          :content="seoDescription"
        />
        <meta v-if="useSchema" itemprop="image" :content="firstCategoryImage" />
        <HowToBuy class="how-modal-button">
          <UiLink
            mode="button"
            font-class="body-l-medium"
            responsive-ico
            icon-after="help-circle"
          >
            Как купить товар
          </UiLink>
        </HowToBuy>
      </div>
    </div>

    <div
      v-if="useSchema"
      itemscope=""
      itemtype="http://schema.org/AggregateOffer"
      itemprop="offers"
    >
      <meta itemprop="offerCount" :content="metaOffers.offer_count" />
      <meta itemprop="highPrice" :content="metaOffers.price_max" />
      <meta itemprop="lowPrice" :content="metaOffers.price_min" />
      <meta itemprop="priceCurrency" content="RUB" />
    </div>
    <products-with-filters
      v-model:count="count"
      :data="data"
      :page-data="pageData"
      :filters-url="`/categories/${data.category_id}/filters`"
      :products-url="`/categories/${data.category_id}/list`"
      :const-products-params="params"
      :discount="isDiscount"
      :retail-block="retailBlock"
      seo-text-show
      @change-data="(e: Event) => $emit('change-data', e)"
      @get-breadcrumbs="(e: Event) => $emit('get-breadcrumbs', e)"
    >
      <template #after-products>
        <FaqImport
          v-if="!isBot"
          class="additional-info-wrap"
          :title="isTitle"
          :items="questions"
        />
        <div v-if="isPreset && dataCategoryId">
          <div
            data-retailrocket-markup-block="673dcf8ae47979fb15764273"
            :data-stock-id="region_id"
            :data-category-id="dataCategoryId"
          />
        </div>
        <PresetsBasic
          class="additional-info-wrap additional-info-wrap--first"
          title="Популярные подборки"
          :items="popularPreset"
          mobile-full-view
        />
        <PresetsBasic
          v-if="!isDiscount"
          class="additional-info-wrap additional-info-wrap--second"
          title="Популярные бренды"
          :items="pageData?.brandPresets"
          mobile-full-view
        />
        <ModelHistory
          class="additional-info-wrap--second"
          root-class="search-page-slider"
        />
      </template>
      <template #listings-top>
        <div
          v-if="topPresetsItems && topPresetsItems.length > 0"
          class="presets-wrap"
        >
          <TopPresets :list="topPresetsItems" />
        </div>
      </template>
    </products-with-filters>
  </div>
</template>
<script lang="ts" src="./CategoryListTs.ts"></script>
<style scoped lang="scss">
.category-list-wrapper {
  .presets-wrap {
    padding: 0;

    .top-presets {
      padding: 0 12px;

      @include md-block {
        padding: 0 20px;
      }

      @include xl-block {
        padding: 0;
      }
    }
  }

  .products-list {
    .additional-info-wrap,
    .model-history {
      padding-top: 40px;
      @include md-block {
        padding-top: 48px;
      }
      @include lg-block {
        padding-top: 64px;
      }
    }

    .additional-info-wrap--first {
      margin-top: 0;
    }

    .additional-info-wrap--second {
      margin-top: -4px;
      @include lg-block {
        margin-top: -8px;
      }
      @include xl-block {
        margin-top: 0;
      }
    }
  }
}

.main-container .text-h1-bold-up {
  display: contents;
  @include xl-block() {
    display: inline-block;
  }
}

.seo-text-wrap {
  padding-top: 40px;
  @include md-block {
    padding-top: 48px;
  }
  @include lg-block {
    padding-top: 64px;
  }
}

.l-top-margin {
  padding-top: 48px;
  @include xl-block() {
    padding-top: 64px;
  }
}

.header-title-category-wrap {
  padding: 16px 0;
  width: 100%;

  @include md-block {
    padding: 24px 0;
  }

  @include xl-block {
    margin: 0 auto;
    padding: 32px 0;
  }
}

.how-modal-button {
  margin-top: 4px;
  display: inline-flex;
  position: relative;
  width: 100%;
  @include lg-block {
    margin-top: 0;
    width: auto;
  }
}

.inline {
  display: inline;
}
</style>
